import { createElement } from 'react';
import { parseInlineMarkdown, parseMarkdownBlocks } from '../chat/message-markdown';

function inline(text: string) {
  return parseInlineMarkdown(text).map((part, index) => {
    if (part.type === 'strong') return <strong key={index}>{part.text}</strong>;
    if (part.type === 'code') return <code key={index}>{part.text}</code>;
    if (part.type === 'link' && /^(https?:\/\/|mailto:)/i.test(part.href)) return <a key={index} href={part.href} target="_blank" rel="noopener noreferrer">{part.text}</a>;
    return part.text;
  });
}
export default function FactoryMarkdown({ text }: { text: string }) {
  return <div className="fx-markdown">{parseMarkdownBlocks(text).map((block, index) => {
    if (block.type === 'heading') return createElement(`h${block.level}`, { key: index }, inline(block.content));
    if (block.type === 'paragraph') return <p key={index}>{inline(block.lines.join('\n'))}</p>;
    if (block.type === 'blockquote') return <blockquote key={index}>{inline(block.lines.join('\n'))}</blockquote>;
    if (block.type === 'code') return <pre key={index}><code>{block.content}</code></pre>;
    if (block.type === 'divider') return <hr key={index} />;
    if (block.type === 'list') return <ul key={index}>{block.items.map((item, i) => <li key={i} style={{ marginLeft: item.level * 16 }}>{inline(item.lines.join('\n'))}</li>)}</ul>;
    if (block.type === 'table') return <div key={index} className="fx-table-scroll"><table><thead><tr>{block.headers.map((cell, i) => <th key={i}>{inline(cell)}</th>)}</tr></thead><tbody>{block.rows.map((row, i) => <tr key={i}>{row.map((cell, j) => <td key={j}>{inline(cell)}</td>)}</tr>)}</tbody></table></div>;
    return null;
  })}</div>;
}
